"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// 👇️ ts-nocheck disables type checking for entire file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// 👇️ ts-ignore ignores any ts errors on the next line
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignoreimport { useEffect, useRef, useState } from "react"
var react_1 = __importDefault(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var loop_wallet_1 = require("../../Loop_Reuseable_Component/packages/loop_wallet");
var constants_1 = require("../../Loop_Reuseable_Component/packages/loop_wallet/constants");
var wallet_module_scss_1 = __importDefault(require("./wallet.module.scss"));
function WalletConnect(props) {
    var showSignup = props.showSignup, setSignupform = props.setSignupform;
    var login = (0, loop_wallet_1.useWallet)().login;
    var fblogin = function () {
        var url = constants_1.REACT_APP_SOCKET_URL + "/login/federated/facebook";
        var newWindow = window.open(url, "name", "height=600,width=600");
        newWindow === null || newWindow === void 0 ? void 0 : newWindow.postMessage(JSON.stringify({ obj: window }), "*");
        if (window.focus) {
            newWindow.focus();
        }
        return false;
    };
    return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Modal.Actions, { children: showSignup ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: wallet_module_scss_1.default.wallet_login_wrapper }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "btn_box" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(loop_wallet_1.LoginWithGoogle, { onClick: login, text: "Join with Google" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: wallet_module_scss_1.default.divider }, { children: (0, jsx_runtime_1.jsx)("span", { children: "or" }) })), (0, jsx_runtime_1.jsx)("button", __assign({ className: "btn loginbtn loginbtn--outline", onClick: function () { return setSignupform(false); } }, { children: "Login to Loop Fans" }))] })) }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: wallet_module_scss_1.default.wallet_login_wrapper }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "btn_box" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)(loop_wallet_1.LoginWithGoogle, { onClick: login, text: "Log in with Google" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: wallet_module_scss_1.default.divider }, { children: (0, jsx_runtime_1.jsx)("span", { children: "or" }) })), (0, jsx_runtime_1.jsx)("button", __assign({ className: "btn loginbtn loginbtn--outline", onClick: function () { return setSignupform(true); } }, { children: "New to Loop Fans? Join Now" }))] })) }))) }) }));
}
exports.default = WalletConnect;
